require('./bootstrap');

require('./app/toggle-password');

require('./app/select-all');

require('./app/select-multiple');

require('./app/submit-form');

require('./app/postal-code');

require('./app/bootstrap-table/bootstrap-table');

import {Tabulator} from 'tabulator-tables';



window.generateTable = function(target, columns, tableData) {
    const table = new Tabulator("#" + target, {
        height: '100px',
        data: JSON.parse(tableData),
        columns: JSON.parse(columns),
        layout: "fitColumns",
        pagination:"local",
        paginationSize:6,
    });
}

// var tabledata = [
//     {id:1, name:"Oli Bob", age:"12", col:"red", dob:""},
//     {id:2, name:"Mary May", age:"1", col:"blue", dob:"14/05/1982"},
//     {id:3, name:"Christine Lobowski", age:"42", col:"green", dob:"22/05/1982"},
//     {id:4, name:"Brendon Philips", age:"125", col:"orange", dob:"01/08/1980"},
//     {id:5, name:"Margret Marmajuke", age:"16", col:"yellow", dob:"31/01/1999"},
// ];
// var table = new Tabulator("#table", {
//     data: tabledata,
//     height:"311px",
//     columns:[
//     {title:"Name", field:"name"},
//     {title:"Progress", field:"progress", sorter:"number"},
//     {title:"Gender", field:"gender"},
//     {title:"Rating", field:"rating"},
//     {title:"Favourite Color", field:"col"},
//     {title:"Date Of Birth", field:"dob", hozAlign:"center"},
//     ],
// });